import { getAmericanTime } from '@helpers/getAmericanTimezone';
import { usePageContext } from '../../../../../../providers/PageProvider';
import { Divider } from '../../styles/Divider';
import { InfoBlock } from '../../styles/InfoBlock';
import { InfoBlockContent } from '../../styles/InfoBlockContent';
import { InfoBlockTitle } from '../../styles/InfoBlockTitle';
import { InfoBlockWrapper } from '../../styles/InfoBlockWrapper';
import { JobSection } from '../../styles/JobSection';
import { JobSectionLeft } from '../../styles/JobSectionLeft';
import { JobSectionRight } from '../../styles/JobSectionRight';
import { AddressBlock } from './components/AddressBlock';
import { MeetingAssignee } from './components/MeetingAssignee';
import { MeetingLinkBlock } from './components/MeetingLinkBlock';

export const ScheduleSection = () => {
  const { job, showSchedule } = usePageContext();

  type meetingType = 'RECORDING_SESSION_REMOTE' | 'RECORDING_SESSION_HYBRID' | 'RECORDING_SESSION_IN_PERSON';
  const meetingTypeNames = {
    RECORDING_SESSION_REMOTE: 'Remote',
    RECORDING_SESSION_HYBRID: 'Hybrid',
    RECORDING_SESSION_IN_PERSON: 'In Person',
  };

  if (!job || !showSchedule) {
    return null;
  }

  return (
    <>
      <JobSection>
        <JobSectionLeft>Schedule</JobSectionLeft>
        <JobSectionRight>
          <InfoBlockWrapper>
            <InfoBlock>
              <InfoBlockTitle>Date and time</InfoBlockTitle>
              <InfoBlockContent>
                {job.meetingDate && job.meetingTime ? (
                  <>
                    {getAmericanTime(job.meetingDate ?? '', false)} {job.meetingTime}
                  </>
                ) : (
                  'Not Set'
                )}
              </InfoBlockContent>
            </InfoBlock>

            <MeetingAssignee />

            <InfoBlock>
              <InfoBlockTitle>Meeting type</InfoBlockTitle>
              <InfoBlockContent>
                {meetingTypeNames[(job.meetingType as meetingType) ?? 'RECORDING_SESSION_REMOTE']}
              </InfoBlockContent>
            </InfoBlock>

            <AddressBlock />

            <MeetingLinkBlock />
          </InfoBlockWrapper>
        </JobSectionRight>
      </JobSection>
      <Divider />
    </>
  );
};
